import styled from "styled-components";

export const Wrapper = styled.div`
  width: 100%;
  text-align: center;
  display: flex;
justify-content: center;
align-items: flex-start;
flex-direction: column;
padding-left: 30px;
padding-right: 30px;
padding-top: 30px;
font-feature-settings: 'clig' off, 'liga' off;
font-family: var(--general-font-family);
max-height: 500px;
overflow-y: auto;
`
export const SummaryTitle = styled.h3`
color: var(--font-color-blue002e5c);
font-size: var(--general-header-font-size);
font-style: normal;
font-weight: var(--general-header-font-weight);
line-height: 32px;
text-align: left;
padding-bottom: 8px;
display: flex;
justify-content: flex-start;
align-items: center;
span{
padding-right: 8px;
}
`
export const DataNotFoundWrapper = styled.div`
display: flex;
flex-direction: column;
justify-content: center;
align-items: center;
background: #F8F8F9;
width: 100%;
height: 104px;
border-top: 1px solid rgba(0, 46, 92, 0.10);
border-bottom: 1px solid rgba(0, 46, 92, 0.10);

span{
color: var(--font-color-grayb5b5c3);
font-size: var(--general-large-body-font-size);
font-style: normal;
font-weight: var(--general-large-body-font-weight);
line-height: 150%; 
}
`

export const DataFoundWrapper = styled.div`
width: 100%;
max-height: 500px;
/* overflow-y: scroll; */
`
export const NumberOfSelections = styled.div`
display: flex;
justify-content: center;
align-items: center;
height: 37.96px;
color: var(--font-color-blue70a0ee);
background: #EAEEFC;
border-bottom: 1px solid rgba(0, 46, 92, 0.10);
margin-bottom: 29px;
span{
    padding-top: 6px;
    padding-bottom: 6px;
}

`
export const SummaryItem = styled.div`
margin-bottom: 20px;

`

export const SummaryItemCharge = styled.div`
  	width: 100%;
	display: flex;
	justify-content: space-between;
`


export const SummaryItemInfo = styled.div`
	display: flex;
	justify-content: flex-start;
	align-items: flex-start;
	flex-direction: column;
`;


export const SummaryItemName = styled.p`
  color: var(--font-color-blue002e5c);
  font-size: var(--general-amount-font-size);
  margin: 0;
`;


export const PaymentAmount = styled.div`
    display: flex;
    justify-content: center;
    flex-direction: column;
    color: var(--font-color-blue002e5c);

`
export const TotalPayment = styled.div`
width: 100%;
display: flex;
justify-content: space-between;
align-items: center;
color: var(--font-color-blue002e5c);
border-top: 1px dashed rgba(0, 46, 92, 0.10);
padding-top:24px;
padding-bottom:24px;

p{
font-size: var(--general-amount-font-size);
font-weight: var(--general-amount-font-weight);
line-height: 13px;
}
span{
font-size: var(--general-large-amount-font-size);
font-style: normal;
font-weight: var(--general-large-amount-font-weight);
line-height: 13px;
}
`
export const TotalPay = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: var(--font-weight-regular);
  font-size: var(--general-amount-font-size);
  line-height: 21px;
  span {
    color: var(--font-color-blue002e5c);
    text-align: right;
    font-weight: var(--font-weight-bold);
    line-height: normal;
    text-transform: capitalize;
  }
`;
export const Discount = styled.div`
width: 100%;
display: flex;
justify-content: space-between;
color: var(--font-color-blue5b7792);
margin-bottom: 5px;
`

export const PayDetails = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  color: var(--font-color-blue002e5c);
  display: flex;
  flex-direction: column;
  gap: 2px;
  margin-bottom: 20px;

  li {
    display: flex;
    justify-content: space-between;
    font-style: normal;
    font-weight: var(--general-body-font-weight);
    font-size: var(--general-body-font-size);
    line-height: 21px;
    
  }
  span {
    display: flex;
    justify-content: space-between;
    font-style: normal;
    font-weight: var(--general-body-font-weight);
    font-size: var(--general-body-font-size);
    line-height: 21px;
    span {
      color: var(--font-color-blue002e5c);
      text-align: right;
      font-family: var(--general-small-header-font-family);
      font-size: var(--general-small-header-font-size);
      font-style: normal;
      font-weight: var(--general-small-header-font-weight);
      line-height: normal;
      text-transform: capitalize;
    }
  }
  p{
    opacity: 0.7;
    color: var(--font-color-blue002e5c);
    text-align: left;
  }
`;

export const DiscountRow = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
`;

export const DiscountLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--font-color-blue002e5c);
  font-size: var(--general-label-font-size);
  font-weight: var(--general-label-font-weight);
`;

export const DiscountAmount = styled.span`
  color: var(--font-color-blue002e5c);
  font-size: var(--general-amount-font-size);
  font-weight: var(--font-weight-regular);
`;

export const FetchDiscountButton = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  background: rgba(37, 85, 239, 0.06);
  border: 1px solid rgba(37, 85, 239, 0.2);
  border-radius: 20px;
  padding: 4px 12px 4px 8px;
  cursor: pointer;
  color: var(--font-color-blue2555ef);
  font-family: var(--general-small-button-font-family);
  font-size: var(--general-small-button-font-size);
  font-weight: var(--general-small-button-font-weight);
  transition: background 0.2s, border-color 0.2s;
  white-space: nowrap;

  &:hover {
    background: rgba(37, 85, 239, 0.12);
    border-color: rgba(37, 85, 239, 0.4);
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }
`;

export const SpinnerIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  animation: ${({ $spinning }) => $spinning ? 'spin 0.8s linear infinite' : 'none'};

  @keyframes spin {
    from { transform: rotate(0deg); }
    to   { transform: rotate(360deg); }
  }
`;

export const TotalDueAmount = styled.div`
	width: 100%;
	display: flex;
	justify-content: space-between;
	align-items: center;
	color: var(--font-color-blue002e5c);
	padding-top: 5px;
	padding-bottom: 24px;
	p {
		font-size: var(--general-amount-font-size);
		font-weight: var(--general-amount-font-weight);
		line-height: 13px;
		margin-bottom: 0;
	}
	span {
		font-size: var(--general-large-amount-font-size);
		font-style: normal;
		font-weight: var(--general-large-amount-font-weight);
		line-height: 13px;
	}
`